import React, { useState } from "react";
import ThemedIcon from "../utils/ThemedIcon";
import Sidebar from "../components/Sidebar";
import { ICONS } from "../constants/icons";
import { useUser } from "../contexts/UserContext";
import { ROUTES } from "../App";
import { useTheme } from "../contexts/ThemeContext";
import { BsSun, BsMoon } from "react-icons/bs";
import { signOut } from "firebase/auth";
import { auth, database, storage } from "../constants/firebase";
import { FiLogOut } from "react-icons/fi";
import useMoveTo from "../constants/navigation";
import DeleteModal from "../components/DeleteModal";
import { ref, remove } from "firebase/database";
import { ref as sRef, listAll, deleteObject } from "firebase/storage";
import MobileHeader from "../components/MobileHeader";
import { clearFcmToken } from "../utils/utils";

const Settings = () => {
    const navigate = useMoveTo();
    const { currentUser, openLogoutModal } = useUser();
    const { isDark, toggleTheme } = useTheme();
    const [showDeleteStories, setShowDeleteStories] = useState(false);
    const [isDeleting, setIsDeleting] = useState(false);
    const [showAltText, setShowAltText] = useState(false);



    const handleDeleteStories = async () => {
        if (!currentUser?.uid) return;

        try {
            setIsDeleting(true)
            // 1. Delete from Realtime Database
            await remove(ref(database, `hostStories/${currentUser.uid}`));

            // 2. Delete from Storage (all files in folder)
            const userFolderRef = sRef(storage, `hostStories/${currentUser.uid}`);
            const allFiles = await listAll(userFolderRef);

            // Delete all files inside the folder
            await Promise.all(allFiles.items.map(fileRef => deleteObject(fileRef)));

            window.showToast("Your stories data has been deleted successfully.", 'success');
            setShowDeleteStories(false);

        } catch (error) {
            console.error("Error deleting stories:", error);
            window.showToast("Failed to delete stories. Please try again.", 'error');
        } finally {
            setIsDeleting(false);
        }
    };


    return (
        <div className="h-screen flex flex-col bg-white dark:bg-[#1A1A1A] text-black dark:text-white">
            <MobileHeader title="Settings" isBackBtn={true} />

            <div className="flex flex-1 overflow-hidden">
                <Sidebar />

                <main className="flex-1 min-h-0 overflow-y-auto pt-5 pb-24 md:pb-20 px-6 bg-main">
                    <div className="flex items-center justify-between">
                        <button onClick={() => navigate(-1)} className="flex-shrink-0 md:block hidden">
                            <img src={ICONS.arrowBack} className="w-4 h-4 md:w-5 md:h-5 grayscale brightness-0 dark:invert" alt="Back" />
                        </button>
                        <h2 className="text-2xl md:text-3xl font-semibold text-main hidden md:block">Settings</h2>
                        <div />
                    </div>

                    <div className="max-w-full mx-auto md:pt-10 pt-3 px-4 md:px-10 space-y-6">
                        <div>
                            {/* Account Section */}
                            <h3 className="text-lg md:text-2xl font-semibold text-gray-900 dark:text-white text-left lg:text-center">
                                Account
                            </h3>
                            <div className="p-3 rounded-2xl mt-4 bg-[#F5F9FE] dark:bg-[#1f1f1f] border border-gray-200 dark:border-gray-700">
                                <div
                                    className="flex items-center space-x-4 px-3 py-3 rounded-md cursor-pointer hover:bg-[#e8edf2] dark:hover:bg-[#2b2b2b]"
                                    onClick={toggleTheme}
                                >
                                    {isDark ? <BsSun className="w-5 h-5" /> : <BsMoon className="w-5 h-5" />}
                                    <p>{isDark ? "Switch to Light Mode" : "Switch to Dark Mode"}</p>
                                </div>

                                <div
                                    className="flex items-center space-x-4 px-3 py-3 rounded-md cursor-pointer hover:bg-[#e8edf2] dark:hover:bg-[#2b2b2b]"
                                    onClick={() => navigate(ROUTES.EDIT_PROFILE)}
                                >
                                    <ThemedIcon src={ICONS.editProfileSettings} width={24} height={24} />
                                    <p>Edit profile</p>
                                </div>

                                {/* <div
                                    className="flex items-center space-x-4 px-3 py-3 rounded-md cursor-pointer hover:bg-gray-100 dark:hover:bg-[#2b2b2b]"
                                    onClick={() => navigate(ROUTES.EDIT_CHAT_BACKGROUND)}
                                >
                                    <ThemedIcon src={ICONS.paint} width={24} height={24} />
                                    <p>Edit chat background</p>
                                </div>

                                <div className="flex items-center space-x-4 px-3 py-3 rounded-md cursor-pointer hover:bg-[#e8edf2] dark:hover:bg-[#2b2b2b]">
                                    <ThemedIcon src={ICONS.notification} width={24} height={24} />
                                    <p>Notifications</p>
                                </div> */}

                                <div
                                    className="flex items-center space-x-4 px-3 py-3 rounded-md cursor-pointer hover:bg-[#e8edf2] dark:hover:bg-[#2b2b2b]"
                                    onClick={() => navigate(ROUTES.CHANGE_PASSWORD)}
                                >
                                    <ThemedIcon src={ICONS.lock} width={24} height={24} />
                                    <p>Change Password</p>
                                </div>
                                {/* <div
                                    className="flex items-center space-x-4 px-3 py-3 rounded-md cursor-pointer hover:bg-[#e8edf2] dark:hover:bg-[#2b2b2b]"
                                    onClick={() => setShowDeleteStories(true)}
                                >
                                    <ThemedIcon src={ICONS.lock} width={24} height={24} />
                                    <p>Delete My Stories Data</p>
                                </div> */}


                                <div
                                    className="flex items-center space-x-4 px-3 py-3 rounded-md cursor-pointer hover:bg-[#e8edf2] dark:hover:bg-[#2b2b2b]"
                                    onClick={() => navigate(ROUTES.DELETE_ACCOUNT)}
                                >
                                    <ThemedIcon src={ICONS.lock} width={24} height={24} />
                                    <p>Delete my account</p>
                                </div>

                                {currentUser?.isAdmin && (
                                    <div
                                        className="flex items-center space-x-4 px-3 py-3 rounded-md cursor-pointer hover:bg-[#e8edf2] dark:hover:bg-[#2b2b2b]"
                                        onClick={() => navigate(ROUTES.CREATE_CHALLENGE)}
                                    >
                                        <ThemedIcon src={ICONS.letterI} width={24} height={24} />
                                        <p>Set Monthly Challenge</p>
                                    </div>

                                )}

                                <div
                                    className="flex items-center space-x-4 px-3 py-3 rounded-md cursor-pointer hover:bg-[#e8edf2] dark:hover:bg-[#2b2b2b]"
                                    onClick={openLogoutModal}
                                >
                                    <FiLogOut className="w-6 h-6" />
                                    <p>Logout</p>
                                </div>
                            </div>

                            {/* Subscription Section */}
                            {currentUser?.role === "Host" && (
                                <>
                                    <h3 className="text-lg md:text-2xl font-semibold text-gray-900 dark:text-white mt-10 text-left lg:text-center">
                                        Subscription
                                    </h3>
                                    <div className="p-3 rounded-2xl mt-4 bg-[#F5F9FE] dark:bg-[#1f1f1f] border border-gray-200 dark:border-gray-700">
                                        <div
                                            className="flex items-center space-x-4 px-3 py-3 rounded-md cursor-pointer hover:bg-[#e8edf2] dark:hover:bg-[#2b2b2b]"
                                            onClick={() => navigate(ROUTES.SUBSCRIPTION_PLAN)}
                                        >
                                            <ThemedIcon src={ICONS.creditCard} width={24} height={24} />
                                            <p>Manage Subscription</p>
                                        </div>
                                    </div>
                                </>
                            )}

                            {/* Support & About Section */}
                            <h3 className="text-lg md:text-2xl font-semibold text-gray-900 dark:text-white mt-10 text-left lg:text-center">
                                Support & About
                            </h3>
                            <div className="p-6 rounded-2xl space-y-4 mt-4 bg-[#F5F9FE] dark:bg-[#1f1f1f] border border-gray-200 dark:border-gray-700">

                                {/* Toggle Text Button */}
                                <div
                                    className="flex items-center space-x-4 px-3 py-3 rounded-md cursor-pointer hover:bg-[#e8edf2] dark:hover:bg-[#2b2b2b]"
                                    onClick={() => setShowAltText(!showAltText)}
                                >
                                    <ThemedIcon src={ICONS.questionMark} width={24} height={24} />
                                    <p>{showAltText ? "info@capecodes.com" : "Ask a question via email"}</p>
                                </div>

                                <div
                                    className="flex items-center space-x-4 px-3 py-3 rounded-md cursor-pointer hover:bg-[#e8edf2] dark:hover:bg-[#2b2b2b]"
                                    onClick={() => window.open("https://app.formbricks.com/s/cmiixxcfr7j8bad01ahna3frl", "_blank", "noopener,noreferrer")}
                                >
                                    <ThemedIcon src={ICONS.questionMark} width={24} height={24} />
                                    <p>Zylen Feedback</p>
                                </div>

                                <div
                                    className="flex items-center space-x-4 px-3 py-3 rounded-md cursor-pointer hover:bg-[#e8edf2] dark:hover:bg-[#2b2b2b]"
                                    // onClick={() => window.open("https://rentry.co/terms-of-service-zylen", "_blank", "noopener,noreferrer")}
                                    onClick={() => navigate(ROUTES.TERM_OF_SERVICE)}
                                >
                                    <ThemedIcon src={ICONS.letterI} width={24} height={24} alt="Info" />
                                    <p>Terms of Service</p>
                                </div>

                                <div
                                    className="flex items-center space-x-4 px-3 py-3 rounded-md cursor-pointer hover:bg-[#e8edf2] dark:hover:bg-[#2b2b2b]"
                                    // onClick={() => window.open("https://www.termsfeed.com/live/bf8eefa4-d69e-4ed8-8e42-ae42fedc5081", "_blank", "noopener,noreferrer")}
                                    onClick={() => navigate(ROUTES.PRIVACY_POLICY)}
                                >
                                    <ThemedIcon src={ICONS.letterI} width={24} height={24} />
                                    <p>Privacy Policy</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <DeleteModal
                        isOpen={showDeleteStories}
                        onClose={() => setShowDeleteStories(false)}
                        onConfirm={handleDeleteStories}
                        message={"Are you sure you want to delete your stories data?"}
                        isDeleting={isDeleting}
                    />

                </main>
            </div>
        </div>
    );
};

export default Settings;
